import { Navigate } from "react-router-dom"
import { useAuth } from "../auth/AuthContext"

/**
 * Props:
 *  - requireSuperadmin: solo rol="admin"/"superadmin" en users (super admin de plataforma)
 *  - requireCompanyMember: user debe pertenecer a una Company (owner o member activo)
 *  - requireCompanyRole: min rol en la empresa (owner|gerente|operador|consulta)
 *  - requireAdmin: alias legacy de requireSuperadmin (deprecated)
 */
const ROLE_LEVEL = { owner: 4, gerente: 3, operador: 2, consulta: 1 }

export default function ProtectedRoute({
  children,
  requireSuperadmin = false,
  requireAdmin = false,           // alias legacy
  requireCompanyMember = false,
  requireCompanyRole = null,
}) {
  const { user, loading } = useAuth()
  if (loading) return <div style={{ padding: 40 }}>Cargando...</div>
  if (!user) return <Navigate to="/login" replace />

  // Superadmin (plataforma)
  const wantSuper = requireSuperadmin || requireAdmin
  if (wantSuper && !["admin", "superadmin"].includes(user.role)) {
    return <Navigate to="/dashboard" replace />
  }

  // Miembro de empresa
  if (requireCompanyMember && !user.companyId) {
    return <Navigate to="/dashboard" replace />
  }

  // Rol minimo en empresa
  if (requireCompanyRole) {
    const lvl = ROLE_LEVEL[user.roleInCompany] || 0
    const need = ROLE_LEVEL[requireCompanyRole] || 0
    if (lvl < need) return <Navigate to="/dashboard" replace />
  }

  return children
}
